export enum PurchaseOrderStatus {
    PendingSupApproval = 'pendingSupApproval',
    PendingReceipt = 'pendingReceipt',
    RejectedBySup = 'rejectedBySup',
    PartiallyReceived = 'partiallyReceived',
    PendingBillPartReceived = 'pendingBillPartReceived',
    PendingBill = 'pendingBill',
    FullyBilled = 'fullyBilled',
    Closed = 'closed',
}
